import server from '@/request';

// 分页获取
export const getAttributeLists = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/pageList', data);
};

// 添加
export const addAttribute = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/add', data);
};

// 更新
export const updateAttribute = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/update', data);
};

// 删除
export const deleteAttribute = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/delete', data);
};

// 启用或禁用
export const enableOrDisableStatus = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/enableOrDisable', data);
};

// 通过id获取
export const detailAttribute = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/detail', data);
};

// 属性明细分页获取
export const getAttributeItemPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/itemPageList', data);
};

// 查询数量
export const getGoodsAttributeCount = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/getCount', data);
};

// 回收站列表
export const getDeletedAttributeList = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/recycleBin/pageList', data);
};

// 还原属性
export const restoreAttribute = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/attribute/recycleBin/restore', data);
};
